// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-wrap[data-v-0ada873c]{text-align:right}[data-v-0ada873c] .set-sms{border-radius:.520833rem!important}[data-v-0ada873c] .el-dialog__header{padding:.989583rem 1.302083rem;background:#f8f8f8;border-radius:.520833rem .520833rem 0 0!important}[data-v-0ada873c] .el-dialog__title{font-size:.833333rem}[data-v-0ada873c] .el-form{width:26.041667rem}[data-v-0ada873c] .hy-btn{background:linear-gradient(90deg,#2079fb,#4cb2fc);color:#fff}", ""]);
// Exports
module.exports = exports;
